<div class="col-xl">
    <form [formGroup]="clientForm" (ngSubmit)="addClient()">
        <div class="card mb-4">
            <div class="card-header d-flex justify-content-between align-items-center">
                <h5 class="mb-0">Datos de facturación</h5>
            </div>
            <div class="card-body">
                <div class="mb-3 p-3 rounded border">
                    <div class="row">
                        <div class="col">
                            <label class="form-label">Nombre del cliente*</label>
                            <div class="input-group input-group-merge">
                                <input type="text" class="form-control"
                                    [ngClass]="clientForm.controls['name'].errors  && !clientForm.controls['name'].pristine ? 'is-invalid' : ''"
                                    formControlName="name" [(ngModel)]="formModelData.name">
                                <div class="invalid-feedback"
                                    *ngIf="clientForm.controls['name'].errors  && !clientForm.controls['name'].pristine">
                                    Ingrese
                                    el nombre de cliente</div>
                            </div>
                        </div>
                        <div class="col">
                            <label class="form-label">Correo Electronico*</label>
                            <div class="input-group input-group-merge">
                                <input type="email" class="form-control"
                                    [ngClass]="clientForm.controls['email'].errors  && !clientForm.controls['email'].pristine ? 'is-invalid' : ''"
                                    formControlName="email" [(ngModel)]="formModelData.email">
                                <div class="invalid-feedback"
                                    *ngIf="clientForm.controls['email'].errors  && !clientForm.controls['email'].pristine">
                                    Ingrese un E-mail valido</div>
                            </div>

                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col">
                            <label class="form-label">RFC*</label>
                            <div class="input-group input-group-merge">
                                <input type="text" class="form-control"
                                    [ngClass]="clientForm.controls['rfc'].errors  && !clientForm.controls['rfc'].pristine ? 'is-invalid' : ''"
                                    formControlName="rfc" [(ngModel)]="formModelData.rfc">
                                <div class="invalid-feedback"
                                    *ngIf="clientForm.controls['rfc'].errors  && !clientForm.controls['rfc'].pristine">
                                    El campo RFC es obligatorio</div>
                            </div>
                        </div>
                        <div class="col">
                            <label class="form-label">Razón Social*</label>
                            <div class="input-group input-group-merge">
                                <input type="text" class="form-control"
                                    [ngClass]="clientForm.controls['business_name'].errors  && !clientForm.controls['business_name'].pristine ? 'is-invalid' : ''"
                                    formControlName="business_name" [(ngModel)]="formModelData.business_name">
                                <div class="invalid-feedback"
                                    *ngIf="clientForm.controls['business_name'].errors  && !clientForm.controls['business_name'].pristine">
                                    El campo razón social es obligatorio</div>
                            </div>
                        </div>

                    </div>
                    <div class="row mt-3">
                        <div class="col">
                            <label class="form-label">Regímen Fiscal*</label>
                            <div class="input-group input-group-merge">
                                <select class="form-select"
                                    [ngClass]="clientForm.controls['fiscal_regime_id'].errors  && !clientForm.controls['fiscal_regime_id'].pristine ? 'is-invalid' : ''"
                                    formControlName="fiscal_regime_id" [(ngModel)]="formModelData.fiscal_regime_id">
                                    <option value="">Seleccione...</option>
                                    <option *ngFor="let item of fiscalRegimes" [value]="item.id">{{item.key}} -
                                        {{item.description}}</option>
                                </select>
                                <div class="invalid-feedback"
                                    *ngIf="clientForm.controls['fiscal_regime_id'].errors  && !clientForm.controls['fiscal_regime_id'].pristine">
                                    El campo regimen fiscal es obligatorio</div>
                            </div>
                        </div>
                        <div class="col">
                            <label class="form-label">Uso CFDI*</label>
                            <div class="input-group input-group-merge">
                                <select class="form-select"
                                    [ngClass]="clientForm.controls['cfdi_use_id'].errors  && !clientForm.controls['cfdi_use_id'].pristine ? 'is-invalid' : ''"
                                    formControlName="cfdi_use_id" [(ngModel)]="formModelData.cfdi_use_id">
                                    <option value="">Seleccione...</option>
                                    <option *ngFor="let item of cfdiUses" [value]="item.id">{{item.key}} -
                                        {{item.description}}</option>
                                </select>
                                <div class="invalid-feedback"
                                    *ngIf="clientForm.controls['cfdi_use_id'].errors  && !clientForm.controls['cfdi_use_id'].pristine">
                                    El campo uso de CFDI es obligatorio</div>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col">
                            <div class="d-flex justify-content-between align-items-center">
                                <label class="form-label mb-0">Domicilio fiscal</label>
                            </div>
                        </div>
                    </div>
                    <div class="row" *ngIf="formModelData.is_fiscal_address">
                        <div class="col">
                            <div class="input-group input-group-merge">
                                <input type="text" class="form-control"
                                    [ngClass]="clientForm.controls['fiscal_address'].errors  && !clientForm.controls['fiscal_address'].pristine ? 'is-invalid' : ''"
                                    [appGooglePlaces]="clientForm.get('fiscal_address')"
                                    (appGooglePlacesPlaceChanged)="onFiscalPlaceChanged($event)"
                                    formControlName="fiscal_address" [(ngModel)]="formModelData.fiscal_address">
                                <div class="invalid-feedback"
                                    *ngIf="clientForm.controls['fiscal_address'].errors  && !clientForm.controls['fiscal_address'].pristine">
                                    El domicilio fiscal es obligatorio</div>
                            </div>
                        </div>
                    </div>
                    <div class="mb-3" *ngIf="!formModelData.is_fiscal_address">
                        <div class="row">
                            <div class="col">
                                <label class="form-label">Calle*</label>
                                <div class="input-group input-group-merge">
                                    <input type="text" class="form-control"
                                        [ngClass]="clientForm.controls['street'].errors  && !clientForm.controls['street'].pristine ? 'is-invalid' : ''"
                                        formControlName="street" [(ngModel)]="formModelData.street">
                                    <div class="invalid-feedback"
                                        *ngIf="clientForm.controls['street'].errors  && !clientForm.controls['street'].pristine">
                                        El campo calle es obligatorio</div>
                                </div>
                            </div>
                            <div class="col">
                                <label class="form-label">Número exterior*</label>
                                <div class="input-group input-group-merge">
                                    <input type="text" class="form-control"
                                        [ngClass]="clientForm.controls['exterior_number'].errors  && !clientForm.controls['exterior_number'].pristine ? 'is-invalid' : ''"
                                        formControlName="exterior_number" [(ngModel)]="formModelData.exterior_number">
                                    <div class="invalid-feedback"
                                        *ngIf="clientForm.controls['exterior_number'].errors  && !clientForm.controls['exterior_number'].pristine">
                                        El número exterior es obligatorio</div>
                                </div>
                            </div>
                            <div class="col">
                                <label class="form-label">Número interior*</label>
                                <div class="input-group input-group-merge">
                                    <input type="text" class="form-control"
                                        [ngClass]="clientForm.controls['interior_number'].errors  && !clientForm.controls['interior_number'].pristine ? 'is-invalid' : ''"
                                        formControlName="interior_number" [(ngModel)]="formModelData.interior_number">
                                    <div class="invalid-feedback"
                                        *ngIf="clientForm.controls['interior_number'].errors  && !clientForm.controls['interior_number'].pristine">
                                        El número interior es obligatorio</div>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col">
                                <label class="form-label">Colonia*</label>
                                <div class="input-group input-group-merge">
                                    <input type="text" class="form-control"
                                        [ngClass]="clientForm.controls['cologne'].errors  && !clientForm.controls['cologne'].pristine ? 'is-invalid' : ''"
                                        formControlName="cologne" [(ngModel)]="formModelData.cologne">
                                    <div class="invalid-feedback"
                                        *ngIf="clientForm.controls['cologne'].errors  && !clientForm.controls['cologne'].pristine">
                                        El campo colonia es obligatorio
                                    </div>
                                </div>
                            </div>
                            <div class="col">
                                <label class="form-label">Localidad*</label>
                                <div class="input-group input-group-merge">
                                    <input type="text" class="form-control"
                                        [ngClass]="clientForm.controls['locality'].errors  && !clientForm.controls['locality'].pristine ? 'is-invalid' : ''"
                                        formControlName="locality" [(ngModel)]="formModelData.locality">
                                    <div class="invalid-feedback"
                                        *ngIf="clientForm.controls['locality'].errors  && !clientForm.controls['locality'].pristine">
                                        El campo localidad es obligatorio</div>
                                </div>
                            </div>
                        </div>

                        <div class="row mt-3">
                            <div class="col">
                                <label class="form-label">Municipio*</label>
                                <div class="input-group input-group-merge">
                                    <input type="text" class="form-control"
                                        [ngClass]="clientForm.controls['municipality'].errors  && !clientForm.controls['municipality'].pristine ? 'is-invalid' : ''"
                                        formControlName="municipality" [(ngModel)]="formModelData.municipality">
                                    <div class="invalid-feedback"
                                        *ngIf="clientForm.controls['municipality'].errors  && !clientForm.controls['municipality'].pristine">
                                        El campo municipio es obligatorio
                                    </div>
                                </div>
                            </div>
                            <div class="col">
                                <label class="form-label">Estado*</label>
                                <div class="input-group input-group-merge">
                                    <input type="text" class="form-control"
                                        [ngClass]="clientForm.controls['state'].errors  && !clientForm.controls['state'].pristine ? 'is-invalid' : ''"
                                        formControlName="state" [(ngModel)]="formModelData.state">
                                    <div class="invalid-feedback"
                                        *ngIf="clientForm.controls['state'].errors  && !clientForm.controls['state'].pristine">
                                        El campo estado es obligatorio</div>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-3">

                            <div class="col">
                                <label class="form-label">Código Postal*</label>
                                <div class="input-group input-group-merge">
                                    <input type="text" class="form-control" (change)="onChangeSearch($event, 1)"
                                        [ngClass]="clientForm.controls['postal_code'].errors  && !clientForm.controls['postal_code'].pristine ? 'is-invalid' : ''"
                                        formControlName="postal_code" [(ngModel)]="formModelData.postal_code">
                                    <div class="invalid-feedback"
                                        *ngIf="clientForm.controls['postal_code'].errors  && !clientForm.controls['postal_code'].pristine">
                                        El codigo postal es obligatorio</div>
                                </div>
                            </div>
                            <div class="col">
                                <label class="form-label">País*</label>
                                <div class="input-group input-group-merge">
                                    <input type="text" class="form-control"
                                        [ngClass]="clientForm.controls['country'].errors  && !clientForm.controls['country'].pristine ? 'is-invalid' : ''"
                                        formControlName="country" [(ngModel)]="formModelData.country">
                                    <div class="invalid-feedback"
                                        *ngIf="clientForm.controls['country'].errors  && !clientForm.controls['country'].pristine">
                                        El campo país es obligatorio</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card mb-4">
            <div class="card-body text-center">
                <button type="submit" class="btn btn-primary me-sm-3 me-1">Guardar cliente</button>
            </div>
        </div>
    </form>
</div>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.7)" size="medium" color="#fff" type="ball-atom">
    <div class="loader"></div>
    <p style="font-size: 20px; color: white">{{text_loading}}</p>
</ngx-spinner>